import {
  ConfirmationItem,
  Skeleton,
  VerticalTimeline,
} from "@gearbox-protocol/ui-kit";
import { useMemo } from "react";
import { Address } from "viem";
import { ccmSigners } from "@/core/signers";
import { useCrossChainMultisig } from "@/hooks/use-cross-chain-multisig";

interface ProposalSignaturesProps {
  isExecuted: boolean;
  signers: Address[];
}

export function ProposalSignatures({
  signers,
  isExecuted,
}: ProposalSignaturesProps) {
  const { isLoading, threshold } = useCrossChainMultisig();

  const hasConfirmations = useMemo(() => signers.length > 0, [signers.length]);

  if (isLoading) {
    return (
      <div className="animate-pulse flex flex-col gap-2">
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-4 w-1/3" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    );
  }

  return (
    <VerticalTimeline
      minWidth={420}
      steps={[
        {
          type: "default",
          status: "success",
          title: "Created",
        },
        {
          type: "default",
          status: hasConfirmations ? "success" : "pending",
          title: `Confirmations (${signers.length} of ${threshold})`,
        },
        {
          type: "extention",
          status: hasConfirmations ? "success" : "not-started",
          children: signers.map(confirmation => (
            <ConfirmationItem
              key={confirmation}
              confirmation={confirmation}
              note={ccmSigners[confirmation.toLowerCase() as Address]}
            />
          )),
        },
        {
          type: "default",
          status: isExecuted
            ? "success"
            : hasConfirmations
              ? "pending"
              : "not-started",
          title: isExecuted ? `Executed` : "Can be executed",
        },
      ]}
    />
  );
}
